import React from "react";
import PageHeader from "../../Components/shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Lead_Header from "./Lead_Header"
const Lead_upload = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader></PageHeader>
          <div className="main-content">
            <div className="row">
              <Lead_Header />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Lead_upload;
